import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Sai Tata </span>
            from <span className="purple"> Cincinnati, OH.</span>
            <br />
            <br />
            I've spent the last 5+ years building backend systems and, more
            recently, shipping AI-powered features into production at real scale.
            At <span className="purple">Kroger (Fortune 25)</span>, I work on
            GenAI data pipelines with{" "}
            <span className="purple">LangChain and OpenAI</span> that plug
            directly into retail operations. I also built{" "}
            <span className="purple">Voycee</span> — a Voice AI product that
            handles restaurant and hospital calls in two languages.
            <br />
            <br />
            Before that, I built the AI scheduling engine at{" "}
            <span className="purple">TeamCal AI</span> and worked deep in{" "}
            <span className="purple">
              Java microservices, Kafka, and high-throughput trading systems at
              DriveWealth
            </span>
            . I'm comfortable across the full stack — from React on the frontend
            to Spring Boot and Python on the backend, all running on AWS.
            <br />
            <br />
            <span className="purple">
              AWS Certified Developer – Associate
            </span>{" "}
            | M.S. Computer Science, Pace University
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Anime
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
